import "../../download/style/download.scss";
import downloadIocn from "../../download/image/normal_u137.svg";
// import './style/story.scss'

let data = {
  index: 0,
  downloadData: [
    {
      type: 2,
      name: "2024叶轮流量计产品说明书.pdf",
      url: "https://static.qifeizn.com/resources/os/download/2024%E5%8F%B6%E8%BD%AE%E6%B5%81%E9%87%8F%E8%AE%A1%E4%BA%A7%E5%93%81%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf",
      releaseDate: "2024-03-04",
    },
    {
      type: 2,
      name: "2024播撒机产品说明书.pdf",
      url: "https://static.qifeizn.com/resources/os/download/2024%E6%92%AD%E6%92%92%E6%9C%BA%E4%BA%A7%E5%93%81%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf",
      releaseDate: "2024-03-04",
    },
    {
      type: 2,
      name: "AG6飞控产品说明书.pdf",
      url: "https://static.qifeizn.com/resources/os/download/AG6%E9%A3%9E%E6%8E%A7%E4%BA%A7%E5%93%81%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf",
      releaseDate: "2024-03-04",
    },
    {
      type: 2,
      name: "BP14无刷隔膜水泵产品说明书.pdf",
      url: "https://static.qifeizn.com/resources/os/download/BP14%E6%97%A0%E5%88%B7%E9%9A%94%E8%86%9C%E6%B0%B4%E6%B3%B5%E4%BA%A7%E5%93%81%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf",
      releaseDate: "2024-03-04",
    },
    {
      type: 0,
      name: 'B100植保无人飞机使用说明书.pdf',
      url: 'https://static.qifeizn.com/resources/os/download/B100%E6%A4%8D%E4%BF%9D%E6%97%A0%E4%BA%BA%E9%A3%9E%E6%9C%BA%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf',
      releaseDate: "2024-03-19",
    },
    {
      type: 0,
      name: 'B22P植保无人机使用说明',
      url: 'https://static.qifeizn.com/resources/os/download/A22P%E6%A4%8D%E4%BF%9D%E6%97%A0%E4%BA%BA%E6%9C%BA%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E.pdf',
      releaseDate: "2024-03-28"
    }
  ],
  value: "",
};
let proluctList = $(".product-list li");
let search = $(".nva-right input");

const getAppInfo = async () => {
  let url =
    process.env.BASE_API +
    "/agrServiceSoftware/getAgrServiceSoftwareLatestInfo";
  let res = await $.ajax({
    url,
    method: "get"
  });
  return {
    type: 3,
    name: "掌上农服" + res.result.latestVersion,
    version: res.result.latestVersion,
    releaseDate: res.result.releaseDate,
    url: "",
  }
};

const getAppDownloadUrl = (version) => {
  let url = process.env.BASE_API + "/agrServiceSoftware/getSoftwareDownloadUrl";
  $.ajax({
    url: url + "?version=" + version,
    method: "get",
    success: function (res) {
      window.open(res.result, "_blank");
    },
  });
};

const moduleSelect = () => {
  proluctList.removeClass("product-active");
  proluctList.eq(data.index).addClass("product-active");
  let list = data.downloadData
    .map((item) => {
      if (item.type == data.index) {
        return item;
      }
    })
    .filter((item) => item);
  render(list);
};

const render = (list = []) => {
  $(".material-list ul").empty();
  if (list.length) {
    list.forEach((item) => {
      if(!item.url){
        $(".material-list ul").append(`
          <li>
            <div class="material-name">${item.name}</div>
            <div class="material-time">${item.releaseDate}</div>
            <div class="material-download material-download-app" data-url="${item.url}" data-version="${item.version}"><span><img src="${downloadIocn}"></img> Download</span><span class="qr-code">Scan code</span></div>
          </li>
          `);
      }else{
        $(".material-list ul").append(`
        <li>
          <div class="material-name">${item.name}</div>
          <div class="material-time">${item.releaseDate}</div>
          <div class="material-download" data-url="${item.url}" data-version="${item.version}"><img src="${downloadIocn}"></img> Download</div>
        </li>
        `);
      }
    });
  } else {
    $(".material-list ul").append("<li>No data</li>");
  }
};

const getUrlKey = (name) => {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
};
const getDownloadData = async () => {
  let data = await $.getJSON('https://resource.qifeizn.com/resources/os/download/get/download.json')
  return data
}

const init = async () => {
  let module = getUrlKey("module");
  data.index = module || 0;
  let [downloadData, appInfo] = await Promise.all([getDownloadData(), getAppInfo()]);
  data.downloadData = [...downloadData, appInfo];


  moduleSelect();
};

init();

$("body").on("click", ".material-download", function () {
  let version = $(this).attr("data-version");
  let url = $(this).attr("data-url");
  if (url) {
    let link = document.createElement("a");
    link.style.display = "none";
    link.target = "_blank";
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    getAppDownloadUrl(version);
  }
});

proluctList.click(function () {
  data.index = $(this).attr("data-type");
  moduleSelect();
});

search.keydown(function (e) {
  if (e.keyCode !== 13) return;
  let value = $(this).val();
  data.index = "";
  proluctList.removeClass("product-active");

  if (value) {
    let list = data.downloadData
      .map((item) => {
        if (item.name.includes(value)) {
          return item;
        }
      })
      .filter((item) => item);

    render(list)
  }
});
